module.exports = __webpack_public_path__ + "img/vim.8805418a.png";